import React from "react"

import { Calendar, Mail, PhoneCall } from "lucide-react"
import { Link } from "react-router-dom"

import ApplicationStepper from "@/components/application/ApplicationStepper"
import AppLayout from "@/components/layout/AppLayout"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card"

const ScreeningPage: React.FC = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 pb-8 md:px-8">
        <ApplicationStepper />

        <h1 className="mb-2 text-center text-2xl font-bold text-jungle md:text-2xl">
          Screening Call
        </h1>
        <p className="mb-8 text-center text-gray-600">
          Thanks for your application. Our team will contact you shortly to schedule your screening
          call.
        </p>

        <div className="mx-auto max-w-md">
          <Card>
            <CardHeader className="text-center">
              <div className="mb-4 flex justify-center">
                <div className="rounded-full bg-green-100 p-3">
                  <PhoneCall className="h-8 w-8 text-green-600" />
                </div>
              </div>
              <CardTitle className="mb-2 text-xl font-bold text-jungle">
                We'll be in touch soon
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="flex items-start space-x-3 rounded-lg bg-gray-50 p-4">
                <div className="rounded-full bg-amber-100 p-2">
                  <Calendar className="h-5 w-5 text-amber-600" />
                </div>
                <p className="text-sm text-gray-600">
                  We'll propose times for your screening call. Please pick what works best for you.
                </p>
              </div>
              <div className="flex items-start space-x-3 rounded-lg bg-gray-50 p-4">
                <div className="rounded-full bg-blue-100 p-2">
                  <Mail className="h-5 w-5 text-blue-600" />
                </div>
                <p className="text-sm text-gray-600">
                  Watch your inbox and phone for updates. Make sure your contact details are
                  up-to-date.
                </p>
              </div>
              <div className="flex items-start space-x-3 rounded-lg bg-gray-50 p-4">
                <div className="rounded-full bg-green-100 p-2">
                  <PhoneCall className="h-5 w-5 text-green-600" />
                </div>
                <p className="text-sm text-gray-600">
                  No action required now — we’ll reach out to you to schedule.
                </p>
              </div>
            </CardContent>
            <CardFooter className="flex justify-center">
              <Link to="/application-status" className="w-full">
                <Button variant="outline" className="w-full">
                  View application status
                </Button>
              </Link>
            </CardFooter>
          </Card>
        </div>
      </div>
    </AppLayout>
  )
}

export default ScreeningPage
